module.exports = __webpack_public_path__ + "img/materialBall.ce60f58e.png";